import {
  getUserInfo,
  getLoginMBList,
  getMBList,
  redPacketList,
  login,
  getBoundUserInfo,
  getCdKey,
} from "@/apis/recall";

const state = {
  // appkey: '100002638',
  token: "",
  coin: "", // 喵币余额
  total_coin: "", // 总喵币余额
  is_return: 0, // 被召回者是否回归
  user_name: "", // 用户名
  last_lottery_times: "", // 剩余抽奖次数
  user_type: 0, // 2.召回者 1.被召回者，
  summon_word: "登录后即可使用召回口令",
  boundUserList: [],
  MBInfo: {},
  redPacketModal: [],
  loginType: "", // 2 无感登录 1 普通登录
  cdKey: "",
  template_id: 0, // 模板id
};

const mutations = {
  CHANGE_RECALL_STATE(state, obj) {
    state = Object.assign(state, obj);
  },
  RESET(state) {
    localStorage.removeItem("token");
    // localStorage.removeItem("tempId");
    state = Object.assign(state, {
      token: "",
      coin: "", // 喵币余额
      total_coin: "", // 总喵币余额
      is_return: 0, // 被召回者是否回归
      user_name: "", // 用户名
      last_lottery_times: "", // 剩余抽奖次数
      user_type: 0, // 2.召回者 1.被召回者，
      summon_word: "登录后即可使用召回口令",
      boundUserList: [],
      MBInfo: {},
      redPacketModal: [],
      cdKey: "",
    });
  },
};

const actions = {
  resetTemp({ commit, state, dispatch }) {
    commit("RESET");
    dispatch("getRedPacketList");
    dispatch("getUserMBList");
  },
  async getUserInfo({ commit, state, dispatch }, callback) {
    try {
      const r = await getUserInfo(state.template_id);
      if (r.ret !== 1) return;
      const obj = {
        summon_word: r.content.recall_code, // 召回码
        coin: r.content.credit, // 喵币余额
        total_coin: r.content.total_credit, // 总喵币余额
        is_return: r.content.is_return || 0, // 被召回者是否回归
        user_name: r.content.user_name, // 用户名
        last_lottery_times: r.content.last_lottery_times, // 剩余抽奖次数
        user_type: r.content.user_type, // 2.召回者 1.被召回者，
      };
      commit("CHANGE_RECALL_STATE", {
        ...obj,
        loginType: 1,
      });
      dispatch("getBoundList");
      dispatch("getLoginMBList");
      dispatch("getRedPacketList");
    } catch (err) {
      if (err.ret === 572 || err.ret === 573) {
        localStorage.removeItem("token");
        commit("RESET");
      }
    }
    callback && callback();
  },
  // 获取红包列表
  async getRedPacketList({ commit, state }) {
    const f = !!state.token;
    const r = await redPacketList(state.template_id, f);
    if (r.ret !== 1) return;
    commit("CHANGE_RECALL_STATE", {
      redPacketModal: r.content.redPackets,
    });
  },
  async userBind({ commit }, data) {},
  /**
   * 获取用户喵币列表
   * @param {*} tempId 模板id
   */
  async getUserMBList({ commit, state }) {
    let r = await getMBList(state.template_id);
    if (r.ret !== 1) return;
    commit("CHANGE_RECALL_STATE", {
      MBInfo: r.content,
    });
  },
  // 用户名密码登录
  async login({ commit, state, dispatch }, options) {
    const r = await login(
      Object.assign({ template_id: state.template_id }, options)
    );
    if (r.ret !== 1) return;
    const obj = {
      token: r.content.token,
      summon_word: r.content.recall_code, // 召回码
      coin: r.content.credit, // 喵币余额
      total_coin: r.content.total_credit, // 总喵币余额
      is_return: r.content.is_return || 0, // 被召回者是否回归
      user_name: r.content.user_name, // 用户名
      last_lottery_times: r.content.last_lottery_times, // 剩余抽奖次数
      user_type: r.content.user_type, // 1.召回者 2.被召回者，
    };
    commit("CHANGE_RECALL_STATE", {
      ...obj,
      loginType: 1,
    });
    localStorage.setItem("token", r.content.token);
    dispatch("getBoundList");
    dispatch("getLoginMBList");
    dispatch("getRedPacketList");
  },
  // 获取召回玩家列表
  async getBoundList({ commit, state, dispatch }) {
    if (state.user_type === 1) {
      const boundInfo = await getBoundUserInfo(state.template_id);
      if (boundInfo.ret !== 1) return;
      commit("CHANGE_RECALL_STATE", {
        boundUserList: boundInfo.content,
      });
    }
  },
  // 获取已登录用户的喵币列表
  async getLoginMBList({ commit, state }) {
    const r = await getLoginMBList(state.template_id);
    if (r.ret !== 1) return;
    commit("CHANGE_RECALL_STATE", {
      MBInfo: r.content,
    });
  },
  showCustomer() {
    // 拉起53客服
    if (window.$53) {
      const api = window.$53.createApi();
      api.push("cmd", "mtalk");
      api.query();
    }
  },
  async getCdKey({ commit, state }) {
    if (state.cdKey) return;
    const r = await getCdKey();
    if (r.ret !== 1) return;
    commit("CHANGE_RECALL_STATE", {
      cdKey: r.content.code,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
